<div class="pds" [class.pds--compact]="compact">
  <!-- Compact: header bell dropdown -->
  <ng-container *ngIf="compact">
    <div class="pds-compact__head">
      <div class="pds-compact__icon" [class.pds-compact__icon--on]="deviceEnabled">
        <ng-container *ngIf="deviceEnabled; else compactBellOff">
          <app-feather-icons icon="bell"></app-feather-icons>
        </ng-container>
        <ng-template #compactBellOff>
          <app-feather-icons icon="bell-off"></app-feather-icons>
        </ng-template>
      </div>
      <div>
        <p class="pds-compact__title">{{ 'notifications.deviceBellTitle' | translate }}</p>
        <p class="pds-compact__status">
          {{
            (deviceEnabled
              ? 'notifications.deviceEnabledOnThisDevice'
              : 'notifications.deviceDisabledOnThisDevice') | translate
          }}
        </p>
      </div>
    </div>

    <div class="pds-compact__toggle-row">
      <span class="pds-compact__toggle-label">
        {{ 'notifications.deviceToggleLabel' | translate }}
      </span>
      <label class="pds-switch">
        <input
          type="checkbox"
          [checked]="deviceEnabled"
          [disabled]="loading"
          (change)="onToggleChange($any($event.target).checked)"
        />
        <span class="pds-switch__slider"></span>
      </label>
    </div>

    <div class="pds-alert pds-alert--warn" *ngIf="browserBlocked">
      <app-feather-icons icon="alert-circle" class="pds-alert__icon"></app-feather-icons>
      <span>{{ 'notifications.deviceBrowserBlocked' | translate }}</span>
    </div>
  </ng-container>

  <!-- Full page panel -->
  <ng-container *ngIf="!compact">
    <div class="pds-hero">
      <div class="pds-hero__icon" [class.pds-hero__icon--off]="!deviceEnabled">
        <ng-container *ngIf="deviceEnabled; else heroBellOff">
          <app-feather-icons icon="bell"></app-feather-icons>
        </ng-container>
        <ng-template #heroBellOff>
          <app-feather-icons icon="bell-off"></app-feather-icons>
        </ng-template>
      </div>
      <div class="pds-hero__text">
        <h4 class="pds-hero__title">{{ 'notifications.pageTitle' | translate }}</h4>
        <p class="pds-hero__sub">{{ 'notifications.pageSubtitle' | translate }}</p>
      </div>
    </div>

    <div class="pds-grid">
      <div class="pds-stat" [class.pds-stat--success]="deviceEnabled" [class.pds-stat--muted]="!deviceEnabled">
        <span class="pds-stat__label">{{ 'notifications.deviceStatusCard' | translate }}</span>
        <span class="pds-stat__value">
          {{
            (deviceEnabled
              ? 'notifications.deviceEnabledOnThisDevice'
              : 'notifications.deviceDisabledOnThisDevice') | translate
          }}
        </span>
      </div>

      <div
        class="pds-stat"
        [class.pds-stat--success]="browserPermission === 'granted'"
        [class.pds-stat--warn]="browserPermission === 'default'"
        [class.pds-stat--danger]="browserPermission === 'denied' || browserPermission === 'unsupported'"
      >
        <span class="pds-stat__label">{{ 'notifications.browserPermissionCard' | translate }}</span>
        <span class="pds-stat__value">
          {{
            (browserPermission === 'granted'
              ? 'notifications.browserGranted'
              : browserPermission === 'default'
                ? 'notifications.browserDefault'
                : browserPermission === 'denied'
                  ? 'notifications.browserDenied'
                  : 'notifications.browserUnsupported') | translate
          }}
        </span>
      </div>

      <div class="pds-stat" [class.pds-stat--success]="status?.has_device_token" [class.pds-stat--muted]="!status?.has_device_token">
        <span class="pds-stat__label">{{ 'notifications.tokenStatusCard' | translate }}</span>
        <span class="pds-stat__value">
          {{
            (status?.has_device_token
              ? 'notifications.tokenRegistered'
              : 'notifications.tokenNotRegistered') | translate
          }}
        </span>
      </div>
    </div>

    <div class="pds-panel">
      <div class="pds-panel__row">
        <div class="pds-panel__info">
          <h5>{{ 'notifications.deviceToggleLabel' | translate }}</h5>
          <p>{{ 'notifications.deviceToggleHint' | translate }}</p>
        </div>
        <label class="pds-switch pds-switch--lg">
          <input
            type="checkbox"
            [checked]="deviceEnabled"
            [disabled]="loading"
            (change)="onToggleChange($any($event.target).checked)"
          />
          <span class="pds-switch__slider"></span>
        </label>
      </div>

      <div class="pds-alert pds-alert--info" *ngIf="browserNeedsPrompt && !deviceEnabled">
        <app-feather-icons icon="info" class="pds-alert__icon"></app-feather-icons>
        <div>
          <strong>{{ 'notifications.browserPromptTitle' | translate }}</strong>
          <p>{{ 'notifications.browserPromptText' | translate }}</p>
        </div>
      </div>

      <div class="pds-alert pds-alert--warn" *ngIf="browserBlocked">
        <app-feather-icons icon="alert-triangle" class="pds-alert__icon"></app-feather-icons>
        <div>
          <strong>{{ 'notifications.bannerDeniedTitle' | translate }}</strong>
          <p>{{ 'notifications.deviceBrowserBlocked' | translate }}</p>
        </div>
      </div>
    </div>

    <div class="pds-info-card">
      <div class="pds-info-card__icon">
        <app-feather-icons icon="smartphone"></app-feather-icons>
      </div>
      <div>
        <h6>{{ 'notifications.perDeviceInfoTitle' | translate }}</h6>
        <p>{{ 'notifications.perDeviceInfoText' | translate }}</p>
        <ul class="pds-info-card__list">
          <li>{{ 'notifications.perDevicePoint1' | translate }}</li>
          <li>{{ 'notifications.perDevicePoint2' | translate }}</li>
          <li>{{ 'notifications.perDevicePoint3' | translate }}</li>
        </ul>
      </div>
    </div>
  </ng-container>
</div>
